import {LanguageAllComponent} from "../all/LanguageAllComponent";
import {ProductsLanguages} from "../../../../ProductsLanguages";

export class LanguageWebsitePickerComponent extends LanguageAllComponent {
    constructor(value?: string) {
        super(value, {search: false}, ProductsLanguages.website);
    }
}